module.exports = __webpack_public_path__ + "img/logoAndTitleNew.1e194d8f.png";